import { Avatar, Button, styled } from '@mui/material'

export const HeroContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.error.light,
  height: 100,
  paddingTop: 70,
  paddingLeft: 16,
  width: '-webkit-fill-available',
  margin: '-12px'
}))

export const AvatarMobile = styled(Avatar)(({ theme }) => ({
  height: 68,
  width: 68,
  fontSize: 24,
  fontWeight: 400,
  backgroundColor: theme.palette.primary.light,
  border: `4px solid ${theme.palette.grey[50]}`,
  marginTop: '-18px'
}))

export const StatusAvatar = styled('div')({
  position: 'absolute',
  bottom: 8,
  right: 8,
  zIndex: 99
})

export const EditButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.info.light,
  color: theme.palette.info.main,
  borderRadius: 16,
  padding: '5px 16px',
  height: 'fit-content'
}))
